document.addEventListener("DOMContentLoaded", function () {
  const activeFlavour = document.querySelector('.slect_your_flavour.active');
  if (activeFlavour) {
    const price = activeFlavour.getAttribute('data-price');
    const title = activeFlavour.getAttribute('data-title');
    document.querySelector('.product_deatils h4').textContent = title;
    document.querySelector('.product_prices span').textContent = price;
  }
  const addToCartButton = document.querySelector('.Qty_and_atcart button.card__link.button');
  const flavourOptions = document.querySelectorAll('.product_collections .slect_your_flavour');
  flavourOptions.forEach(function (option) {
    option.addEventListener('click', function () {
      flavourOptions.forEach(el => el.classList.remove('active'));
      this.classList.add('active');
      const price = this.getAttribute('data-price');
      const title = this.getAttribute('data-title');
      const isDisabled = this.hasAttribute('disabled') || this.classList.contains('disabled');
      document.querySelector('.product_deatils h4').textContent = title;
      document.querySelector('.product_prices span').textContent = price;
      if (isDisabled) {
        addToCartButton.textContent = 'Sold Out';
        addToCartButton.style.pointerEvents = 'none';
        addToCartButton.style.opacity = '0.5';
      } else {
        addToCartButton.textContent = 'Add to Cart';
        addToCartButton.style.pointerEvents = 'auto';
        addToCartButton.style.opacity = '1';
      }
    });
  });
});



$(document).on('click', '.Qty_and_atcart button.card__link.button', function (e) {
  e.preventDefault();
  const podid = parseInt($('.slect_your_flavour.active').attr('data-id'), 10);
  const qty = parseInt($('.Qty_and_atcart input').val(), 10);
  if (isNaN(podid) || isNaN(qty) || qty <= 0) {
    console.error("Invalid product ID or quantity.");
    return;
  }
  const submitButton = this;
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type']; // Browser sets this when using FormData
  const formData = new FormData();
  formData.append('id', podid);
  formData.append('quantity', qty);
  const cartdrawer = document.querySelector('cart-drawer.drawer');
  const cartId = [
      "cart-drawer",
      "cart-icon-bubble"
  ]
  if (cartdrawer) {
    formData.append('sections', cartId);
    formData.append('sections_url', window.location.pathname);
    cartdrawer.setActiveElement(document.activeElement);
  }
  config.body = formData;
  fetch(routes.cart_add_url, config)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      return response.json();
    })
    .then(response => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: podid,
          errors: response.description,
          message: response.message
        });
        submitButton.error = true;
        return;
      }
      if (!cartdrawer) {
        window.location.href = window.routes.cart_url;
        return;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: podid
      });
      cartdrawer.renderContents(response);
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    })
    .finally(() => {
      if (cartdrawer && cartdrawer.classList.contains('is-empty')) {
        cartdrawer.classList.remove('is-empty');
      }
    });
});



document.addEventListener("DOMContentLoaded", function () {
  const input = document.getElementById("LiveSearchInput");
  const resultsBox = document.getElementById("LiveSearchResults");

  let debounceTimer;

  if(!input) return;

  input.addEventListener("input", function () {
    const query = input.value.trim();

    clearTimeout(debounceTimer);

    if (query.length < 2) {
      resultsBox.style.display = "none";
      resultsBox.innerHTML = "";
      return;
    }

    debounceTimer = setTimeout(() => {
      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`)
        .then((res) => res.json())
        .then((data) => {
          const products = data.resources.results.products;
          if (products.length > 0) {
            resultsBox.innerHTML = products
              .map(
                (product) => `
                  <a href="${product.url}" class="live-search-item">
                    <img src="${product.image}" alt="${product.title}" />
                    <span>${product.title}</span>
                  </a>`
              )
              .join("");
            resultsBox.style.display = "block";
          } else {
            resultsBox.innerHTML = "<div class='no-results'>No results found</div>";
            resultsBox.style.display = "block";
          }
        });
    }, 200);
  });

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".live-search-wrapper")) {
      resultsBox.style.display = "none";
    }
  });
});






//footer js

  // document.addEventListener("DOMContentLoaded", function () {
  //   // Check if the current URL contains the product slug
  //   if (window.location.pathname === '/products/hanson-original-vodka') {
  //     const footer = document.querySelector('#shopify-section-sections--16974846525524__footer-footer');
  //     if (footer) {
  //       footer.style.backgroundColor = '#bc030d';

  //       // Optional: Save in localStorage to persist after refresh
  //       localStorage.setItem('vodkaFooterColor', '#bc030d');
  //     }
  //   } else {
  //     // If user navigates to other page, remove the localStorage item
  //     localStorage.removeItem('vodkaFooterColor');
  //   }
  // });

  // // Apply stored background color on page load
  // window.addEventListener('load', function () {
  //   const color = localStorage.getItem('vodkaFooterColor');
  //   if (color && window.location.pathname === '/products/hanson-original-vodka') {
  //     const footer = document.querySelector('#shopify-section-sections--16974846525524__footer-footer');
  //     if (footer) {
  //       footer.style.backgroundColor = color;
  //     }
  //   }
  // });

